var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"value":_vm.opened,"color":"#6F87FF","min-width":"0"}},[_vm._v(_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }